import React from 'react';
import { AlertTriangle, ArrowLeft } from 'lucide-react';
import { useQueryParams } from '../hooks/useQueryParams';

interface InvalidWebsiteStateProps {
  error?: string;
}

const InvalidWebsiteState: React.FC<InvalidWebsiteStateProps> = ({ error }) => {
  const { returnUrl } = useQueryParams();

  const handleGoBack = () => {
    if (returnUrl) {
      window.location.href = returnUrl;
    } else {
      window.history.back();
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F6FD] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg border border-[#BCBCBC] shadow-[0_2px_6px_0_rgba(0,0,0,0.16)] p-8 text-center">
          <div className="mb-6">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-8 h-8 text-orange-600" />
            </div>
            <h1 className="text-xl font-semibold text-gray-800 mb-2">
              Sitio web no válido
            </h1>
            <p className="text-gray-600 text-sm">
              {error || 'El sitio web especificado no existe o no tienes permisos para acceder a él.'}
            </p>
          </div>
          
          <div className="space-y-3">
            <button
              onClick={handleGoBack}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-[#6150AD] hover:bg-[#5041a0] text-white rounded-lg font-medium transition-colors duration-200"
            >
              <ArrowLeft className="w-4 h-4" />
              Volver
            </button>
            
            <p className="text-xs text-gray-500">
              Si crees que esto es un error, contacta al soporte técnico.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvalidWebsiteState;